import React from "react";

interface TranslationOptions {
  id: string;
  message: string;
}

interface PluralOptions {
  zero?: string;
  one: string;
  other: string;
}

interface SelectOptions extends Record<string, string> {
  other: string;
}

interface TransProps {
  id?: string;
  children: React.ReactNode;
}

// Core translation function
// Always applies placeholder replacement regardless of the translation source
const translate = ({ id, message }: TranslationOptions): string => {
  const translation = message || id;

  return translation;
};

export const t = (options: TranslationOptions): string => translate(options);

export const plural = (count: number, options: PluralOptions): string => {
  if (count === 0 && options.zero) return options.zero;
  return count === 1 ? options.one : options.other;
};

export const select = (value: string, options: SelectOptions): string => {
  return options[value] || options.other;
};

// Trans component
export const Trans: React.FC<TransProps> = ({ id, children }) => {
  return <span id={id}>{children}</span>;
};
